import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { push } from "react-router-redux";
import styled from "styled-components";
import sirens from "../media/sirens.mp4";
import english from "../media/english_flag.png";
import welsh from "../media/welsh_flag.png";

import SearchBar from "../components/SearchBar";

import {
  searchCrimesByLocation,
  searchAvailability,
  toggleAdvanced,
  changeDate,
  noAddress
} from "../actions/search";

const Container = styled.div`
  background: #130809;
  width: 100vw;
  height: 100vh;
  padding: 24px;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-conent: center;
  align-itemscenter;
  video {
    width: 150%;
    margin: auto 0px;
    position: absolute;
    top: 0;
    left: 0;
    filter: blur(40px);
  }
`;

const Flag = styled.img`
  width: 32px;
  margin-bottom: -9px;
`;

const Title = styled.h1`
  position: relative;
  color: white;
  font-size: 40px;
  font-family: Helvetica Neue, arial, sans-serif;
  font-weight: 600;
  text-align: center;
  margin: 16px 0px 40px;
`;

const Tag = styled.p`
  position: relative;
  margin: 0;
  color: white;
  font-size: 22px;
  font-family: Helvetica Neue, arial, sans-serif;
  font-weight: 400;
  text-align: center;
  margin-bottom: 10px;
`;

const SearchButton = styled.button`
  position: relative;
  z-index: 2;
  width: 100%;
  background: rgba(50, 112, 250, 1);
  border: none;
  height: 50px;
  border-radius: 40px;
  font-size: 18px;
  color: white;
  margin-top: 0px;
  font-weight: 600;
  outline: none;
`;

const ExpandButton = styled.p`
  position: relative;
  z-index: 2;
  font-size: 14px;
  color: white;
  text-align: center;
  &:hover {
    text-decoration: underlined;
  }
`;

const SearchOptions = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px;
`;

const SearchForm = styled.form`
  width: 100vw;
  max-width: 600px;
  align-self: center;
  padding: 20px;
`;

const Label = styled.p`
  color: white;
  margin: 0 20px 0 0;
`;

const Select = styled.select`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  height: 40px;
  border-radius: 40px;
  background: rgba(255, 255, 255, 0.1);
  border: 3px solid rgba(255, 255, 255, 0.6);
  outline: none;
  font-size: 18px;
  color: white;
  padding: 0px 25px 0px 20px;
`;

class SearchContainer extends Component {
  componentDidMount() {
    this.props.searchAvailability();
  }

  componentWillReceiveProps(nextProps) {
    const { currentSearch, searchComplete } = nextProps.search;
    if (this.props.search.searchComplete !== searchComplete && searchComplete) {
      this.props.push(
        `/map/${currentSearch.lat}/${currentSearch.lng}/${currentSearch.date}`
      );
    }
  }

  handleSearch(data) {
    const date = this.props.search.currentSearch.date;
    const address = data.value;
    if (address.length < 2) {
      this.props.noAddress();
      return;
    }
    this.props.searchCrimesByLocation({
      date,
      address
    });
  }

  handleDateChange(date) {
    this.props.changeDate(date);
  }

  renderSearchOptions() {
    return (
      <SearchOptions>
        <Label>Date</Label>
        <Select onChange={e => this.handleDateChange(e.target.value)}>
          {this.props.search.availability.map(d =>
            <option key={d.date} value={d.date}>
              {d.date}
            </option>
          )}
        </Select>
      </SearchOptions>
    );
  }

  render() {
    return (
      <Container>
        <video loop autoPlay playsInline>
          <source src={sirens} type="video/mp4" />
        </video>
        <Title>crimecrunch</Title>
        <Tag>crunching crime data for</Tag>
        <Tag>
          <Flag src={english} /> and <Flag src={welsh} />
        </Tag>
        <SearchForm
          onSubmit={e => {
            e.preventDefault();
            this.handleSearch(this.address);
          }}
        >
          <SearchBar
            innerRef={node => (this.address = node)}
            placeholder="Enter Postcode"
          />
          <ExpandButton onClick={() => this.props.toggleAdvanced()}>
            search options
          </ExpandButton>
          {this.props.search.showAdvanced ? this.renderSearchOptions() : null}
          <SearchButton>
            {this.props.search.isSearching
              ? "Contacting Police..."
              : "Fetch Report"}
          </SearchButton>
        </SearchForm>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  search: state.search
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    Object.assign(
      {},
      {
        searchCrimesByLocation,
        searchAvailability,
        noAddress,
        toggleAdvanced,
        changeDate,
        push
      }
    ),
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchContainer);



// WEBPACK FOOTER //
// ./src/containers/SearchContainer.js